import React from 'react';
import { connect } from 'react-redux';

// Actions
// @ts-ignore
import { requestLoadDocumentSet } from 'services/documentSets/actions';

interface OwnProps {
    documentSetId: number;
}

interface DispatchProps {
    requestLoadDocumentSet: typeof requestLoadDocumentSet;
}

type Props = OwnProps & DispatchProps;

export class DocumentSetRequest extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { documentSetId, requestLoadDocumentSet: loadDocumentSet } =
            this.props;

        loadDocumentSet(documentSetId);
    }

    render(): null {
        return null;
    }
}

export default connect(undefined, { requestLoadDocumentSet })(
    DocumentSetRequest
);
